import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "k-discount-card" }
const _hoisted_2 = { class: "q-pa-md bg-white flex items-center justify-between k-discount-card__header" }
const _hoisted_3 = { class: "row items-center no-wrap gap-xs" }
const _hoisted_4 = {
  key: 0,
  class: "fs-13px fw-500 text-cool-gray-100"
}
const _hoisted_5 = { class: "bg-white q-pt-md overflow-hidden k-discount-card__body" }
const _hoisted_6 = { class: "q-mb-none fs-13px fw-500 text-cool-gray-100" }
const _hoisted_7 = { class: "q-mb-none fs-13px fw-500 text-cool-gray-100" }

interface IProps {
  type?: 'auto' | 'variable' | 'basic'
  disable?: boolean
  rate: string
  kind: string
  name: string
  createdAt: string
  text?: Record<PropertyKey, string>
  color?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KDiscountCard' },
  __name: 'KDiscountCard',
  props: {
    type: { default: 'auto' },
    disable: { type: Boolean, default: false },
    rate: {},
    kind: {},
    name: {},
    createdAt: {},
    text: { default: () => ({
    active: 'Active',
    inactive: 'Inactive',
    autoApplyDiscount: 'Auto Apply Discount',
    variableDiscount: 'Variable Discount',
    basicDiscount: 'Basic Discount',
    discountOn: 'Discount on',
    created: 'Created',
  }) },
    color: { default: '#0066ff' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "a32193cc": (_ctx.color)
}))




return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_status = _resolveComponent("k-status")!
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_k_icon, {
          name: "discount-2",
          size: "24px",
          color: __props.disable ? 'cool-gray-70' : 'cool-gray-100'
        }, null, 8, ["color"]),
        (!__props.disable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.type === 'auto'
              ? __props.text?.autoApplyDiscount
              : __props.type === 'variable'
                ? __props.text?.variableDiscount
                : __props.text?.basicDiscount), 1))
          : _createCommentVNode("", true)
      ]),
      (!__props.disable)
        ? (_openBlock(), _createBlock(_component_k_status, {
            key: 0,
            hoverless: "",
            "border-color": "cool-gray-30",
            color: "white",
            label: !__props.disable ? __props.text?.active : __props.text?.inactive,
            status: !__props.disable ? 'var(--success-70)' : 'var(--cool-gray-60)',
            "text-color": "cool-gray-100"
          }, null, 8, ["label", "status"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_k_divider, {
      size: "md",
      class: "k-discount-card__divider",
      dotted: ""
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h2", {
        class: _normalizeClass(["q-mt-md q-mb-sm fs-23px text-center fw-600", [!__props.disable ? 'text-cool-gray-100' : 'text-cool-gray-60']])
      }, _toDisplayString(__props.rate), 3),
      _createElementVNode("p", {
        class: _normalizeClass(["q-mb-xl fs-15px fw-600 text-center", [!__props.disable ? 'text-cool-gray-100' : 'text-cool-gray-60']])
      }, _toDisplayString(__props.name), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["q-pa-md flex items-center justify-between gap-sm relative-position", [!__props.disable ? 'k-discount-card__footer' : 'bg-cool-gray-40']])
      }, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(`${__props.text?.discountOn} ${__props.kind}`), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(`${__props.text?.created}: ${__props.createdAt}`), 1)
      ], 2)
    ])
  ]))
}
}

})